import { Divider, DividerProps, Grid, GridSize } from '@mui/material';
import React from 'react';

export interface GridDividerProps extends DividerProps {
    lg?: boolean | GridSize | undefined;
    md?: boolean | GridSize | undefined;
    sm?: boolean | GridSize | undefined;
    xs?: boolean | GridSize | undefined;
}
export const GridDivider: React.FC<GridDividerProps> = React.memo(
    ({ xs, sm, md, lg, ...otherProps }) => {
        return (
            <Grid item xs={xs ? xs : 12} sm={sm} md={md} lg={lg}>
                <Divider variant='fullWidth' {...otherProps} />
            </Grid>
        );
    }
);
